import { render } from "./CreateLO.vue?vue&type=template&id=06c1f52e&scoped=true"
import script from "./CreateLO.vue?vue&type=script&lang=js"
export * from "./CreateLO.vue?vue&type=script&lang=js"

import "./CreateLO.vue?vue&type=style&index=0&id=06c1f52e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c1f52e"]])

export default __exports__